import {
  model,
  Model,
  prop,
  modelAction,
  ModelCreationData,
} from 'mobx-keystone';

@model('bpEwells/PerformanceUnit')
export default class PerformanceUnit extends Model({
  id: prop<number>(),
  name: prop<string>(''),
  isActive: prop<boolean>(),
}) {
  @modelAction
  update(data: ModelCreationData<PerformanceUnit>) {
    Object.assign(this, data);
  }
}
